
	import ModeloCadastro from '@/views/paginas/sigap/modelos/ModeloCadastro.vue';   
    import { Options   } from "vue-class-component";   
    import {  Alocacao } from "./Alocacao";  
    import   SiteUtils   from '@/assets/ts/aplicacao/site';  
    import $ from "jquery" 

    @Options({
        name: "AlocacaoCadastro",
        components: {   },  
        emits: [  'locacao-alterado'],  
    }) 
    export default class AlocacaoCadastro extends ModeloCadastro {
         
        async created()  {  
            this.titulo = 'Opção de Lotação' ;
            this.campos =  Alocacao.campos();  
            await this.service.getOpcao().then(response =>{ 
               this.campos.unshift(
                    {
                        nome: "opcao",
                        type: "select",
                        label: "Opção",
                        sm: 6,
                        lg: 4, 
                        disabled: false,
                        options: response.map((item) => { return { value: item.id, label: item.nome.replaceAll('_' , ' ') } })
                    },
                );
            });
        }
    
        public getdados(){   
            let dados = JSON.parse(JSON.stringify(this.formulario));  
            dados.MatriculaId = this.$route.params.id; 
            return dados;
        }
 
        public sucesso(){  
            this.$emit("locacao-alterado", null);    
            $("[data-bs-dismiss='modal']").trigger({ type: "click" }); 
        }

         public salvar(){ 
            if( this.processando   ){
                return;
            }
            this.processando = true ;  
            let dados = this.getdados() ;  
            setTimeout(() => {  
                this.service.cadastrar(   dados )
                .then(response => { 
                    SiteUtils.toastSucesso('Cadastrado com sucesso! ' ,  response.message  );
                    this.sucesso();   
                    this.formulario.opcao =  null;
                    this.formulario.UnidadeId =  null;
                    this.processando = false ; 
                    this.editando = false ;
                }) 
                .catch(error => {
                    this.processando = false ;
                    SiteUtils.toastErro('Error! ' ,  error.data.message  );
                });  
            }, 100); 
        }  

    } 
